<template>
  <div>
    <h1 class="h2">{{ title }}</h1>

    <v-card outlined style="padding: 1em; margin-top: 1em;">
      <v-form v-model="valid" ref="form" @submit.prevent="submit">
        <template>
          <v-autocomplete
            v-model="selectedOffice"
            :rules="[rules.required]"
            :items="office"
            label="事業所コード"
            outlined
            chips
            item-text="name"
            item-value="code"
            prepend-icon="mdi-form-select"
            return-object
          ></v-autocomplete>

          <v-autocomplete
            v-model="selectedEmployee"
            :rules="[rules.required]"
            :items="employeeList"
            label="申請確認者"
            outlined
            clearable
            multiple
            chips
            item-text="name"
            prepend-icon="mdi-form-select"
            return-object
          />
        </template>

        <div class="d-flex flex-row-reverse">
          <v-btn type="login" color="success">完了</v-btn>
        </div>
      </v-form>
    </v-card>

    <v-card class="mt-8" style="padding: 1em;">
      <v-card-title>
        <span class="text-h4">{{ title }}</span>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          prepend-inner-icon="mdi-magnify"
          label="簡易検索"
          outlined
          rounded
          dense
        ></v-text-field>
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="contents"
        :search="search"
        multi-sort
      >
        <template v-slot:item.actions="{ item }">
          <v-btn
            color="primary"
            small
            elevation="0"
            @click="handleAction(item)"
          >
            編集
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import Common from "@/mixins/common";
import Forms from "@/mixins/forms";
import Api from "@/mixins/api";
import ShowDialogs from "@/mixins/showDialogs";

export default {
  name: "ApprovalPetitionDetails",
  mixins: [Common, Forms, Api, ShowDialogs],

  data() {
    return {
      params: null,
      sort: null,
      selectedOffice: [],
      office: [],
      selectedEmployee: [],
      employeeList: [],
      title: "申請確認者設定",

      rules: {
        required: v =>
          (!!v && (Array.isArray(v) ? v.length > 0 : true)) || "必須項目です。"
      },
      search: "",
      headers: [],
      items: [],
      contents: []
    };
  },

  methods: {
    getNameCodeMap(list) {
      return new Map(
        list.map(obj => {
          return [obj.name, obj.code];
        })
      );
    },

    getListOfName(list) {
      return list.map(item => item);
    },

    async submit() {
      const isValid = this.$refs.form.validate();
      if (!isValid) {
        return;
      }

      this.$loading();

      try {
        const payload = {
          affiliationList: Array.isArray(this.selectedOffice)
            ? this.selectedOffice
            : [this.selectedOffice],
          confirmerList: this.selectedEmployee
        };

        await this.$post(this.Paths.petitioncreate, payload);
        console.log("get : ", payload);

        this.selectedEmployee = [];
        this.selectedOffice = [];
        this.$refs.form.resetValidation();
        this.$info("更新しました。");
      } catch (e) {
        this.$error(e.message);
      } finally {
        this.getPetition();
        this.$unloading();
      }
    },
    async getUsers(value) {
      return await this.$get(this.Paths.shainSorted, "query=" + value);
    },

    async getPetition() {
      try {
        const petitionList = await this.$get(this.Paths.petitionFindAll);
        this.items = petitionList;

        const officeName = this.office.filter(k => {
          return [...new Set(this.items.map(c => c.affiliationId))].includes(
            Number(k.code)
          );
        });
        console.log("officeName", officeName);

        const keys = Object.keys(officeName[0] || {});
        const headerLabels = {
          name: "所属"
        };

        this.headers = keys.slice(0, 2).map(key => ({
          text: headerLabels[key] || key,
          value: key,
          sortable: true,
          divider: true
        }));

        this.headers.push({
          text: "確認",
          value: "actions",
          sortable: false,
          align: "center"
        });
        this.contents = officeName;
      } catch (error) {
        console.log(error);
      }
    },

    handleAction(item) {
      console.log("clicked for:", item);

      const params = {
        office: item,
        petition: this.items.filter(k => k.affiliationId == item.code),
        employeeName: this.employeeList
      };
      this.$router.push({ name: "ApprovalPetitionDetails_new", params });
    }
  },

  async created() {
    console.log("created", this.$route.params, this.args);

    try {
      const code1 = this.$store.state.shozokuCode1;
      const o = await this.$get(this.Paths.shozoku);
      this.office = o;

      this.selectedOffice = this.office.filter(e => e.refcode === code1);

      const employee = await this.getUsers("");
      this.employeeList = this.getListOfName(employee);
      this.getPetition();
    } catch (e) {
      this.$error(e.message);
    } finally {
      this.$unloading();
    }
  }
};
</script>

<style>
.v-data-table td {
  background: #f0f8ff;
}

.v-data-table tr:nth-child(odd) td {
  background: #fff;
}

.v-data-table tr:hover td {
  background-color: #eee;
}
</style>
